import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { toast } from "react-toastify";

const MobileMenu = ({ isVisible, toggleMenu, menuItems }) => {
    const [metaData, setMetaData] = useState({});
    const [settings, setSettings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get("/business-settings");
                setSettings(response.data.data.data);
            } catch (err) {
                setError(err);
                toast.error("Failed to load business settings.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (Array.isArray(settings)) {
            const meta = {};
            settings.forEach((setting) => {
                if (setting.type === "header_logo_path") {
                    meta.header_logo_path = setting.value;
                }
                if (setting.type === "contact_address") {
                    meta.contact_address = setting.value;
                }
                if (setting.type === "website_name") {
                    meta.website_name = setting.value;
                }
                if (setting.type === "contact_phone") {
                    meta.contact_phone = setting.value;
                }
                if (setting.type === "contact_email") {
                    meta.contact_email = setting.value;
                }
                if (setting.type === "facebook_link") {
                    meta.facebook_link = setting.value;
                }
                if (setting.type === "twitter_link") {
                    meta.twitter_link = setting.value;
                }
                if (setting.type === "instagram_link") {
                    meta.instagram_link = setting.value;
                }
                if (setting.type === "linkedin_link") {
                    meta.linkedin_link = setting.value;
                }
                if (setting.type === "contact_email") {
                    meta.contact_email = setting.value;
                }
                if (setting.type === "contact_phone") {
                    meta.contact_phone = setting.value;
                }
            });
            setMetaData(meta);
        }
    }, [settings]);

    if (!isVisible) return null;

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading data</div>;
    }

    // const staticMenuItems = [
    //     { title: "Bedding", link: "/bedding" },
    //     { title: "Curtain and Drapes", link: "/curtain-and-drapes" },
    //     { title: "Wall Paper", link: "/wall-paper" },
    //     { title: "Window Blinds", link: "/window-blinds" },
    //     { title: "Table Linen", link: "/table-linen" },
    //     { title: "Mats and Rugs", link: "/mats-and-rugs" },
    //     { title: "Bath Linen", link: "/bath-linen" },
    // ];

     const staticMenuItems = [
        { title: "Home", link: "/" },
        { title: "About Us", link: "/about-us" },
        { title: "Product", link: "/products" },
        { title: "Services", link: "/" },
        { title: "Contact Us", link: "/contact-us" },
    ];


    const renderMenuItems = () => {
        return staticMenuItems.map((item, index) => (
            <li key={index}>
                <Link to={item.link}>{item.title}</Link>
            </li>
        ));
    };

    return (
        <div className="mobile-menu">
            <div className="menu-backdrop" onClick={toggleMenu}></div>
            <nav className="menu-box justify-content-around">
                <div className="upper-box">
                    <Link to="/">
                        <div className="nav-logo">
                            <img
                                src="/images/logo/Logo.png"
                                alt="Elley Decor"
                            />
                        </div>
                    </Link>
                    <div className="close-btn" onClick={toggleMenu}>
                        <i className="icon fa fa-times"></i>
                    </div>
                </div>
                <ul className="navigation clearfix">
                    {renderMenuItems()}
                </ul>
                <ul className="contact-list-one">
                    <li className="text-white">
                        <i className="icon lnr-icon-phone-handset text-white"></i>
                        <span className="title text-white">Call Now</span>
                        <div className="text">
                            <Link to={`tel:${metaData.contact_phone}`}className="text-white">
                                {metaData.contact_phone}
                            </Link>
                        </div>
                    </li>
                    <li>
                        <i className="icon lnr-icon-envelope1 text-white"></i>
                        <span className="title text-white">Send Email</span>
                        <div className="text">
                            <Link to={`mailto:${metaData.contact_email}`} className="text-white">
                                {metaData.contact_email}
                            </Link>
                        </div>
                    </li>
                    <li>
                        <i className="icon lnr-icon-map-marker text-white"></i>
                        <span className="title text-white">Address</span>
                        <div className="text text-white">{metaData.contact_address}</div>
                    </li>
                </ul>
               <div className="social-icons d-flex justify-content-around gap-1">
                      {metaData.instagram_link && (
                        <a
                          href={metaData.instagram_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="social-icon insta"
                          style={{ fontSize: 20 }}
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      )}

                      {metaData.facebook_link && (
                        <a
                          href={metaData.facebook_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="social-icon face"
                          style={{ fontSize: 20 }}
                        >
                          <i className="fab fa-facebook"></i>
                        </a>
                      )}

                      {metaData.contact_phone && (
                        <a
                          href={`https://wa.me/${metaData.contact_phone}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="social-icon whats"
                          style={{ fontSize: 20 }}
                        >
                          <i className="fab fa-whatsapp"></i>
                        </a>
                      )}
                    </div>
            </nav>
        </div>
    );
};

export default MobileMenu;
